export const SET_SYSTEM_STATUS_MESSAGES = "SET_SYSTEM_STATUS_MESSAGES";
export const GET_SYSTEM_STATUS_MESSAGES = "GET_SYSTEM_STATUS_MESSAGES";
export const SET_CURRENT_SYSTEM_STATUS_MESSAGES =
  "SET_CURRENT_SYSTEM_STATUS_MESSAGES";
export const SAVE_SYSTEM_STATUS_MESSAGE = "SAVE_SYSTEM_STATUS_MESSAGE";
export const GET_CURRENT_SYSTEM_STATUS_MESSAGES =
  "GET_CURRENT_SYSTEM_STATUS_MESSAGES";
export const DELETE_SYSTEM_STATUS_MESSAGE = "DELETE_SYSTEM_STATUS_MESSAGE";

export const setCurrentSystemStatusMessages = (currentMessages: any) => ({
  type: SET_CURRENT_SYSTEM_STATUS_MESSAGES,
  currentMessages,
});

export const setSystemStatusMessages = (messages: any) => ({
  type: SET_SYSTEM_STATUS_MESSAGES,
  messages,
});

const initialState = {
  messages: null,
  currentMessages: null,
};

export const systemStatusMessageReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case SET_SYSTEM_STATUS_MESSAGES:
      const { messages } = action;
      return { ...state, messages };
    case SET_CURRENT_SYSTEM_STATUS_MESSAGES:
      const { currentMessages } = action;
      return { ...state, currentMessages };
    default:
      return state;
  }
};
